var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCallIncoming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 0.967773C0.489856 0.967773 0.320286 1.03801 0.195262 1.16304C0.0702379 1.28806 0 1.45763 0 1.63444C0 4.64023 1.19404 7.5229 3.31946 9.64832C5.44487 11.7737 8.32755 12.9678 11.3333 12.9678C11.5101 12.9678 11.6797 12.8975 11.8047 12.7725C11.9298 12.6475 12 12.4779 12 12.3011V9.96777C12 9.79096 11.9298 9.62139 11.8047 9.49637C11.6797 9.37135 11.5101 9.30111 11.3333 9.30111C10.5 9.30111 9.7 9.16777 8.95333 8.92111C8.72 8.84777 8.46 8.90111 8.27333 9.08111L6.80667 10.5478C4.92 9.58777 3.37333 8.04777 2.41333 6.15444L3.88 4.68111C4.06667 4.50777 4.12 4.24777 4.04667 4.01444C3.8 3.26777 3.66667 2.46777 3.66667 1.63444C3.66667 1.45763 3.59643 1.28806 3.4714 1.16304C3.34638 1.03801 3.17681 0.967773 3 0.967773H0.666667ZM10.6667 6.30111V5.30111H8.33333L12 1.63444L11.3333 0.967773L7.66667 4.63444V2.30111H6.66667V6.30111H10.6667Z",
    fill: "#1677FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCallIncoming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/call-incoming.f3e1fa2b80f1b33bdb9557dc36618f2b.svg";